/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Docs_TitleInputs */

const en_docs_title = /** @type {(inputs: Docs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project documents`)
};

const id_docs_title = /** @type {(inputs: Docs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen proyek`)
};

/**
* | output |
* | --- |
* | "Project documents" |
*
* @param {Docs_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const docs_title = /** @type {((inputs?: Docs_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Docs_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_docs_title(inputs)
	return en_docs_title(inputs)
});